import { toaster } from "@pathwright/ux/src/components/chakra/ui/toaster"
import { useEffect } from "react"
import { useSelectPeopleContext } from "./SelectPeopleContext"

// Very basic error handling for the (hopefully rare) selection errors.
const SelectError = () => {
  const { addPeopleToState } = useSelectPeopleContext()

  useEffect(() => {
    if (addPeopleToState.error) {
      toaster.create({
        title: "An error occurred",
        type: "error",
        duration: 5000,
        closable: true
      })
    }
  }, [addPeopleToState.error])

  return null
}

export default SelectError
